export default {
	date: "DD.MM.YYYY",
	dateTime: "DD.MM.YYYY, HH:mm",
	dateTimeWithSeconds: "DD.MM.YYYY, HH:mm:ss",
	time: "HH:mm",
	timeWithSeconds: "HH:mm:ss",
	monthYear: "MM.YYYY"
};
